/* eslint-disable no-empty,@typescript-eslint/no-unused-vars,radix */

xplenty.directive('databaseDestinationEditor', [
  '$timeout',
  '$translate',
  function ($timeout, $translate) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./database-destination-editor.html'),

      replace: true,

      controller: [
        '$scope',
        function ($scope) {
          $scope.onRecordsChange = (records) => {
            $scope.component.column_mappings = records;
          };

          if (typeof $scope.component.parallel === 'string') {
            try {
              $scope.component.parallel = parseInt($scope.component.parallel);
            } catch (e) {}
          }

          if (typeof $scope.component.batch_size === 'string') {
            try {
              $scope.component.batch_size = parseInt($scope.component.batch_size);
            } catch (e) {}
          }
        },
      ],
    };
  },
]);
